import SingleSelect from 'components/Select';
// import Select from 'react-select';
import { Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import './index.css';
import { getAttributeValues } from 'services/ManageCustomerBase';
import InputField from 'components/InputField';
import ToastHelper from 'general/helpers/ToastHelper';
import { ATTRIBUTE_NAME_TO_SHOW } from 'const';

function Properties(props) {
  let {
    property,
    change,
    indexId,
    attributeChange,
    option,
    onChange,
    onChangeSub,
    onChangeShow,
    defaultValue,
    defaultOption,
    defaultSubOption,
  } = props;
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState({ 0: { name: 'chọn thuộc tính' } });
  const [selected_Option, setSelectedOption] = useState({});
  const [selected_Value, setSelectedValue] = useState({});
  const [numberClickOr, setNumberClickOr] = useState([1]);
  const [showProperty, set_showProperty] = useState(false);
  const [indexShowProperty, set_indexShowProperty] = useState(null);
  const [indexProperty, set_indexProperty] = useState(null);
  const [attributeName, set_attributeName] = useState({});
  const divRef = useRef(null);
  const btnRef = useRef(null);
  const btnSaveRef = useRef(null);
  const errorRef = useRef(null);
  const [dataType, setDataType] = useState({});
  const [operators, setOperators] = useState({});
  const [subAttributes, set_subAttributes] = useState([]);
  const [subValue, set_subValue] = useState([]);
  const [subAttributesValue, set_subAttributesValue] = useState({});
  const [subAttributesValueSelect, set_subAttributesValueSelect] = useState({});
  const [select_operator, setSelect_operator] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [list, set_list] = useState([]);
  const [titleDay, set_titleDay] = useState('30 ngày gần đây');
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [showTab, setShowTab] = useState(1);

  const [subOption, set_subOption] = useState({});
  const [subOptionSelect, set_subOptionSelect] = useState({});
  const [showSubOption, set_showSubOption] = useState(false);

  let many = ['in', 'notIn'];
  let only = ['eq', 'lte', 'lt', 'gte', 'gt', 'ne', 'arrayContain'];

  const [Value, setValue] = useState([]);
  const [StartValue, setStartValue] = useState(null);
  const [EndValue, setEndValue] = useState(null);
  const [manyValue, setManyValue] = useState([]);

  useEffect(() => {
    if (defaultValue != null) {
      // console.log(defaultValue);
      let list = [];
      let showName = {};
      let Operator = {};
      let atr = {};
      let dtTp = {};
      let subAtr = {};
      for (let id in defaultValue) {
        list.push(Number(id));
        const identityName = defaultValue[id][0]?.name || defaultValue[id][0]?.value[0]?.name;
        showName[id] = {
          identityName: identityName,
          name: ATTRIBUTE_NAME_TO_SHOW[identityName]?.name,
          // type: ATTRIBUTE_NAME_TO_SHOW[identityName].type,
        };
        Operator[identityName] = ATTRIBUTE_NAME_TO_SHOW[identityName]?.operators;
        dtTp[identityName] = ATTRIBUTE_NAME_TO_SHOW[identityName]?.type;

        if (ATTRIBUTE_NAME_TO_SHOW[identityName]?.subAttributes) {
          subAtr[identityName] = ATTRIBUTE_NAME_TO_SHOW[identityName]?.subAttributes;
        }
        atr = Object.assign({}, atr, { [id]: identityName });
        // console.log(defaultValue[id][0]?.name);
      }
      if (defaultSubOption != undefined) {
        set_subOptionSelect(defaultSubOption);
      }
      set_subAttributes(subAtr);
      setSelected(showName);
      setNumberClickOr(list);
      setOperators(Operator);
      setDataType(dtTp);
      set_attributeName(atr);
      setSelectedValue(defaultValue);
    }

    if (defaultOption != null) {
      setSelectedOption(defaultOption);
    }
  }, [defaultOption, defaultValue]);

  useEffect(() => {
    if (option != null) setData(option);
  }, [option]);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (showProperty && divRef.current && !divRef.current.contains(e.target)) {
        set_showProperty(false);
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);

    // Clean up
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [showProperty]);

  useEffect(() => {
    if (!showProperty) {
      set_list([]);
    }
  }, [showProperty]);

  async function onclick_Multiselect() {
    // setShowModal(true);
  }

  useEffect(() => {
    if (dataType[attributeName[indexProperty == null ? 0 : indexProperty]] == 1) {
      setShowTab(2);
    }
  }, [dataType]);

  useEffect(() => {
    change(numberClickOr);
  }, [numberClickOr]);

  useEffect(() => {
    async function refesh() {
      let obj = Object.assign({}, subAttributesValue);
      for (let item in subAttributes) {
        for (let i = 0; i < subAttributes[item].length; i++) {
          if (!(subAttributes[item][i]?.identityName in subAttributesValue)) {
            const data = await getAttributeValues(subAttributes[item][i]?.identityName);
            obj[subAttributes[item][i]?.identityName] = data.data.data;
          }
          // console.log(subAttributes[item][i]?.identityName);
        }
      }
      if (Object.keys(obj).length != 0) {
        set_subAttributesValue(obj);
      }
    }
    refesh();
  }, [subAttributes]);

  useEffect(() => {
    if (indexProperty in attributeName) {
      if (attributeName[indexProperty].dataType != '3') {
        attributeChange(attributeName[indexProperty]);
        // console.log(attributeName[indexProperty])
      }
    }
  }, [attributeName, indexProperty]);

  const handleChange = (selectedOption) => {
    setManyValue(selectedOption);
  };

  useEffect(() => {
    if (select_operator?.opSign == 'between') {
      setEndValue(null);
      setStartValue(null);
      if (btnSaveRef != null && btnRef.current != null) btnSaveRef.current.disabled = true;
    } else if (select_operator != null) {
      // if (btnSaveRef != null && btnRef.current != null) btnSaveRef.current.disabled = false;
    }
  }, [select_operator]);

  const Save = () => {
    let data = Object.assign({}, selected_Option);
    let dataValue = Object.assign({}, selected_Value);
    let value = '';
    let values = [];

    if (select_operator?.opSign == 'between') {
      if (StartValue == null || EndValue == null) {
        return;
      }
      values = [
        {
          op: 'and',
          value: [
            { op: 'lte', name: attributeName[indexProperty], value: EndValue.value },
            { op: 'gte', name: attributeName[indexProperty], value: StartValue.value },
          ],
        },
      ];

      value = `${select_operator.name}: ${StartValue.name ?? StartValue.value} <= X <= ${
        EndValue.name ?? EndValue.value
      }`;
    } else {
      if (many.includes(select_operator?.opSign)) {
        if (dataType[attributeName[indexProperty]] == '3') {
          const dates = Value.value.trim().split(',');
          let dateAfter = [];
          for (let item of dates) {
            if (!isValidDate(item)) {
              ToastHelper.showError('Nhập sai định dạng');
              return;
            }
            dateAfter.push(item.split('/').reverse().join('-'));
          }
          value = `${select_operator.name} ${dates.join(',')}`;
          values = dateAfter;
        } else if (showTab == 1) {
          value = `${select_operator.name} ${StartValue.name || StartValue.label} to ${
            EndValue.name || EndValue.label
          }`;
          values = Array.from(
            { length: Math.abs(EndValue.value - StartValue.value) + 1 },
            (_, i) => Math.min(StartValue.value, EndValue.value) + i
          );
        } else {
          value = `${select_operator.name} ${manyValue.map((item) => item.label).join(',')}`;
          values = manyValue.map((item) => item.value);
        }
      } else if (!many.includes(select_operator?.opSign)) {
        value = `${select_operator.name} ${Value.name ?? Value.value}`;
        values = Value.value;
      } else if (
        dataType[attributeName[indexProperty]] == 1 &&
        many.includes(select_operator?.opSign)
      ) {
        value = `${select_operator.name} ${StartValue.name} and ${EndValue.name}`;
        values = [StartValue.value, EndValue.value];
      }
    }

    if (values.length == 0) {
      return;
    }

    if (indexProperty in dataValue) {
      if (select_operator?.opSign == 'between') {
        dataValue = {
          ...dataValue,
          [indexProperty]: [
            ...dataValue[indexProperty],
            {
              op: 'and',
              value: [
                { op: 'lte', name: attributeName[indexProperty], value: [EndValue.value] },
                { op: 'gte', name: attributeName[indexProperty], value: [StartValue.value] },
              ],
            },
          ],
        };
      } else
        dataValue = {
          ...dataValue,
          [indexProperty]: [
            ...dataValue[indexProperty],
            {
              op: select_operator?.opSign,
              name: selected[indexProperty].identityName,
              value: values,
            },
          ],
        };
    } else {
      if (select_operator?.opSign == 'between') {
        dataValue[indexProperty] = [
          {
            op: 'and',
            value: [
              { op: 'lte', name: attributeName[indexProperty], value: [EndValue.value] },
              { op: 'gte', name: attributeName[indexProperty], value: [StartValue.value] },
            ],
          },
        ];
      } else {
        dataValue[indexProperty] = [
          {
            op: select_operator?.opSign,
            name: selected[indexProperty].identityName,
            value: values,
          },
        ];
      }
    }

    if (values.length == 0 || select_operator?.opSign == null) {
      return;
    }

    if (indexProperty in data) {
      data = { ...data, [indexProperty]: [...data[indexProperty], value] };
    } else {
      data[indexProperty] = [value];
    }

    setSelectedValue(dataValue);
    setSelectedOption(data);
    onChange(dataValue);
    onChangeShow(data);
  };

  function isValidDate(dateString) {
    // Tách chuỗi ngày thành các thành phần
    var parts = dateString.split('/');
    var year = parseInt(parts[2], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[0], 10);

    // Kiểm tra các giá trị cơ bản
    if (isNaN(year) || isNaN(month) || isNaN(day) || month < 1 || month > 12) {
      return false;
    }

    // Tạo đối tượng Date từ các thành phần đã tách
    var date = new Date(year, month - 1, day);

    // Kiểm tra lại các thành phần của đối tượng Date
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  }

  useEffect(() => {
    if (indexProperty == null || !subOption?.[selected?.[indexProperty]?.identityName]) return;
    let dataValue = Object.assign({}, subOptionSelect);
    let obj = subOption?.[selected?.[indexProperty]?.identityName];
    var result = Object.keys(obj).map((key) => obj[key]);
    dataValue = {
      ...dataValue,
      [indexProperty]: result,
    };
    onChangeSub(dataValue);
    set_subOptionSelect(dataValue);
  }, [subOption]);

  return (
    <div className="container-fluid gap-3">
      {numberClickOr.length > 0 && (
        <div>
          <label className="pt-3">
            <h5>Chọn thuộc tính</h5>
          </label>
        </div>
      )}
      <div className="pb-3">
        {numberClickOr.map((item, i) => (
          <div className="row" key={i}>
            <div className="col flex inline-flex items-center gap-2">
              <div
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                style={{ height: '34.5px' }}
              >
                <div
                  className="d-flex justify-content-between cursor-pointer"
                  ref={btnRef}
                  onClick={(event) => {
                    if (showProperty == false) {
                      set_showProperty(!showProperty);
                      set_indexShowProperty(item);
                      const boundingBtnRect = btnRef.current.getBoundingClientRect();
                      setMousePosition({
                        x: event.clientX - boundingBtnRect.left + 110,
                        y: event.clientY - 110,
                      });
                    }
                  }}
                >
                  <span
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '150px',
                    }}
                  >
                    {selected[item] &&
                    selected[item].identityName &&
                    selected[item].identityName != null
                      ? selected[item].name
                      : 'Chọn thuộc tính'}
                  </span>
                  <i className="fa fa-angle-down icon-1x" />
                </div>
              </div>
              {subAttributes?.[selected[item]?.identityName] && (
                <button
                  type="button"
                  className="flex justify-between text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700"
                  onClick={() => {
                    set_showSubOption(true);
                    set_indexProperty(item);
                  }}
                >
                  <i className="fa fa-edit icon-1x btn-blue" />
                </button>
              )}
            </div>
            <div className="col-8">
              <div
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                // style={{ height: '34.5px' }}
              >
                {selected_Option?.[item] &&
                  selected_Option?.[item]?.map((option, index) => {
                    return (
                      <div
                        key={index}
                        className="m-1 gap-3 flex justify-between text-gray-900 border border-gray-200 rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                      >
                        <span>{option}</span>
                        <div
                          className="cursor-pointer text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-xs px-2 py-1 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700"
                          onClick={() => {
                            let options = Object.assign({}, selected_Option);
                            options[item].splice(index, 1);
                            setSelectedOption(options);

                            let data = Object.assign({}, selected_Value);
                            data[item].splice(index, 1);
                            if (data[item].length == 0) {
                              delete data[item];
                            }
                            setSelectedValue(data);
                            onChange(data);
                          }}
                        >
                          <i className="fa fa-trash icon-sm-1x" />
                        </div>
                      </div>
                    );
                  })}
                <button
                  type="button"
                  className="flex justify-between text-gray-900 bg-white border focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                  onClick={() => {
                    if (item in selected_Option) {
                      setShowModal(true);
                      onclick_Multiselect();
                      set_indexProperty(item);
                      setManyValue([]);
                      // setSelect_operator(null);
                    } else {
                      setShowModal(false);
                    }
                  }}
                  data-target={`#StaticBackdrop${indexId}`}
                  data-toggle="modal"
                >
                  <i className="fa fa-plus icon-1x btn-blue" />
                </button>
              </div>
            </div>
            <div className="col d-flex justify-content-between flex inline-flex items-center">
              <div>
                <button
                  type="button"
                  className={`${
                    item != numberClickOr[numberClickOr.length - 1] ? 'd-none' : ''
                  } text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800`}
                  onClick={() => {
                    let data = [...numberClickOr];
                    data.push(Math.max(...numberClickOr) + 1);
                    setNumberClickOr(data);
                  }}
                >
                  OR
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  onClick={() => {
                    setNumberClickOr(numberClickOr.filter((it) => it != item));
                    let options = Object.assign({}, selected_Option);
                    delete options[item];
                    setSelectedOption(options);

                    onChange(options);
                  }}
                >
                  X
                </button>
              </div>
            </div>
            {i != numberClickOr.length - 1 && <span className="container-fluid">OR</span>}
          </div>
        ))}
      </div>
      {showProperty && (
        <div
          className="d-flex gap-1 overlay position-absolute z-3"
          ref={divRef}
          style={{ left: mousePosition.x, top: mousePosition.y }}
        >
          <div>
            <ul className="w-48 text-sm font-medium text-gray-900 bg-white border cursor-pointer">
              {property.map((item, index) => (
                <li
                  key={index}
                  className="w-full px-4 py-2 border-b border-gray-200 rounded-t-lg dark:border-gray-600 d-flex justify-content-between align-items-center"
                  onClick={() => {
                    if (item.list?.length > 0) {
                      set_list([item.list]);
                    } else {
                      setDataType({ ...dataType, [item.identityName]: item.dataType });
                      set_attributeName({
                        ...attributeName,
                        [indexShowProperty]: item.identityName,
                        dataType: item.dataType,
                      });
                      setOperators({ ...operators, [item.identityName]: item.operators });
                      if (item?.subAttributes) {
                        set_subAttributes({
                          ...subAttributes,
                          [item.identityName]: item?.subAttributes,
                        });
                      }

                      let subop = Object.assign({}, subOptionSelect);
                      delete subop?.[indexShowProperty];
                      set_subOptionSelect(subop);

                      set_list([]);
                      set_showProperty(false);

                      let option = Object.assign({}, selected_Option);
                      option[indexShowProperty] = [];
                      setSelectedOption(option);

                      let data = Object.assign({}, selected);
                      if (indexShowProperty in selected) {
                        data[indexShowProperty] = {
                          name: item.name,
                          identityName: item.identityName,
                        };
                      } else {
                        data = {
                          ...selected,
                          [indexShowProperty]: { name: item.name, identityName: item.identityName },
                        };
                      }
                      setSelected(data);
                    }
                  }}
                >
                  <span>{item.name}</span>
                  {item.list?.length > 0 && <i className="fa fa-angle-right icon-1x" />}
                </li>
              ))}
            </ul>
          </div>
          {list.length > 0 &&
            list?.map((item, index) => (
              <div key={index}>
                <ul className="w-48 text-sm font-medium text-gray-900 bg-white border cursor-pointer">
                  {item.map((child, index) => (
                    <li
                      key={index}
                      className="w-full px-4 py-2 border-b border-gray-200 rounded-t-lg dark:border-gray-600 d-flex justify-content-between align-items-center"
                      onClick={() => {
                        if (child.list?.length > 0) {
                          let data = [...list];

                          if (data.includes(child.list)) {
                            return;
                          }
                          data.push(child.list);
                          set_list(data);
                        } else {
                          setDataType({ ...dataType, [child.identityName]: child.dataType });
                          set_attributeName({
                            ...attributeName,
                            [indexShowProperty]: child.identityName,
                            dataType: child.dataType,
                          });
                          setOperators({ ...operators, [child.identityName]: child.operators });
                          if (child?.subAttributes) {
                            set_subAttributes({
                              ...subAttributes,
                              [child.identityName]: child?.subAttributes,
                            });
                          }
                          let subop = Object.assign({}, subOptionSelect);
                          delete subop?.[indexShowProperty];
                          set_subOptionSelect(subop);
                          set_list([]);
                          // setSelected(child.name);
                          set_showProperty(false);

                          let option = Object.assign({}, selected_Option);
                          option[indexShowProperty] = [];
                          setSelectedOption(option);

                          let data = Object.assign({}, selected);
                          if (indexShowProperty in selected) {
                            data[indexShowProperty] = {
                              identityName: child.identityName,
                              name: child.name,
                            };
                          } else {
                            data = {
                              ...selected,
                              [indexShowProperty]: {
                                identityName: child.identityName,
                                name: child.name,
                              },
                            };
                          }
                          setSelected(data);
                        }
                      }}
                    >
                      <span>{child.name}</span>
                      {child.list?.length > 0 && <i className="fa fa-angle-right icon-1x" />}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      )}
      {showModal && (
        <div
          className="modal fade"
          id={`StaticBackdrop${indexId}`}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="w-full flex flex-col gap-3">
                  <SingleSelect
                    label={'Điều kiện'}
                    data={operators[attributeName[indexProperty]]}
                    displayValue={'name'}
                    value={(item) => {
                      setSelect_operator(item);
                    }}
                    // defaultOption={"Chọn điều kiện"}
                  />
                  {select_operator != null &&
                    (select_operator?.opSign == 'between' ? (
                      dataType[attributeName[indexProperty]] != '3' ? (
                        <div>
                          <div className="d-flex justify-content-between gap-3">
                            <div className="form-group mb-0">
                              <div className="w-150px">
                                <div>
                                  <div className="w-full text-center">{`<=`}</div>
                                  <SingleSelect
                                    data={data || []}
                                    displayValue={'name'}
                                    value={(item) => {
                                      if (item.value > EndValue?.value) {
                                        btnSaveRef.current.disabled = true;
                                        errorRef.current.classList.remove('d-none');
                                      } else {
                                        btnSaveRef.current.disabled = false;
                                        errorRef.current.classList.add('d-none');
                                      }
                                      setStartValue(item);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col text-gray-900 justify-content-end">
                              <b>VALUE</b>
                            </div>
                            <div className="form-group mb-0">
                              <div className="w-150px">
                                <div>
                                  <div className="w-full text-center">{`<=`}</div>
                                  <SingleSelect
                                    data={data || []}
                                    displayValue={'name'}
                                    value={(item) => {
                                      if (item.value < StartValue?.value) {
                                        btnSaveRef.current.disabled = true;
                                        errorRef.current.classList.remove('d-none');
                                      } else {
                                        btnSaveRef.current.disabled = false;
                                        errorRef.current.classList.add('d-none');
                                      }
                                      setEndValue(item);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div ref={errorRef} className="d-none pt-5 text-center text-danger">
                            Bên trái phải nhỏ hơn phải
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="d-flex align-items-center justify-between">
                            <div className="form-group mb-0">
                              <div className="d-flex justify-content-between align-items-start">
                                <label htmlFor="startDate" className="font-weight-bolder">
                                  Ngày bắt đầu
                                </label>
                              </div>
                              <div className="w-100">
                                <div>
                                  <input
                                    className="form-control"
                                    type="date"
                                    name="startDate"
                                    placeholder="dd/MM/YYYY"
                                    maxLength=""
                                    data-toggle=""
                                    autoComplete="off"
                                    step="1"
                                    // value={formatDate(startDate, 'yyyy-MM-dd')}
                                    onChange={(e) => {
                                      if (e.target.value > EndValue?.value) {
                                        btnSaveRef.current.disabled = true;
                                        errorRef.current.classList.remove('d-none');
                                      } else {
                                        btnSaveRef.current.disabled = false;
                                        errorRef.current.classList.add('d-none');
                                      }
                                      setStartValue({ value: e.target.value });
                                      // console.log(e.target.value);
                                      // changePickDate
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group mb-0">
                              <div className="d-flex justify-content-between align-items-start">
                                <label htmlFor="endDate" className="font-weight-bolder">
                                  Ngày kết thúc
                                </label>
                              </div>
                              <div className="w-100">
                                <div>
                                  <input
                                    className="form-control"
                                    type="date"
                                    name="endDate"
                                    placeholder="Ngày kết thúc..."
                                    maxLength=""
                                    data-toggle=""
                                    autoComplete="off"
                                    step="1"
                                    // value={formatDate(endDate, 'yyyy-MM-dd')}
                                    onChange={(e) => {
                                      if (e.target.value < StartValue?.value) {
                                        btnSaveRef.current.disabled = true;
                                        errorRef.current.classList.remove('d-none');
                                      } else {
                                        btnSaveRef.current.disabled = false;
                                        errorRef.current.classList.add('d-none');
                                      }
                                      // console.log(e.target.value);
                                      setEndValue({ value: e.target.value });
                                      // console.log(e.target.value);
                                      // changePickDate
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div ref={errorRef} className="d-none pt-5 text-center text-danger">
                            Bên trái phải nhỏ hơn phải
                          </div>
                        </div>
                      )
                    ) : dataType[attributeName[indexProperty]] == '3' ? (
                      many.includes(select_operator?.opSign) ? (
                        <div>
                          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Ngày nhập dưới dạng (DD/MM/yyyy) cách nhau bởi dấu <b>(,)</b>
                          </label>
                          <div className="w-100">
                            <div>
                              <InputField
                                // label={'Mô tả (*)'}
                                placeholder={'Nhập ngày'}
                                style={'w-full'}
                                value={(item) => setValue({ value: item })}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Ngày
                          </label>
                          <div className="w-100">
                            <div>
                              <input
                                className="form-control"
                                type="date"
                                placeholder="dd/MM/YYYY"
                                autoComplete="off"
                                step="1"
                                onChange={(e) => {
                                  setValue({ value: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    ) : many.includes(select_operator?.opSign) ? (
                      <div>
                        <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400 cursor-pointer">
                          <li
                            className={`me-2 ${
                              dataType[attributeName[indexProperty]] == 1 ? 'd-none' : ''
                            }`}
                            onClick={() => {
                              setShowTab(1);
                            }}
                          >
                            <a
                              aria-current="page"
                              className={`${
                                showTab == 1
                                  ? 'inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500'
                                  : 'inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300'
                              }`}
                            >
                              Khoảng giá trị
                            </a>
                          </li>
                          <li
                            className="me-2"
                            onClick={() => {
                              setShowTab(2);
                            }}
                          >
                            <a
                              className={`${
                                showTab == 2
                                  ? 'inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500'
                                  : 'inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300'
                              }`}
                            >
                              Danh sách giá trị
                            </a>
                          </li>
                        </ul>
                        <div className="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
                          {/* <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">Profile Tab</h3> */}
                          {showTab == 1 && dataType[attributeName[indexProperty]] == 2 ? (
                            <div>
                              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Giá trị
                              </label>
                              <div className="d-flex justify-content-between gap-3">
                                <div className="form-group mb-0">
                                  <div className="w-150px">
                                    <div>
                                      <SingleSelect
                                        data={data || []}
                                        displayValue={'name'}
                                        value={(item) => {
                                          setStartValue(item);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col text-gray-900 justify-center">
                                  đến
                                </div>
                                <div className="form-group mb-0">
                                  <div className="w-150px">
                                    <div>
                                      <SingleSelect
                                        data={data || []}
                                        displayValue={'name'}
                                        value={(item) => {
                                          setEndValue(item);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Giá trị
                              </label>
                              <Select
                                mode="multiple"
                                allowClear={true}
                                filterOption={(input, option) =>
                                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                style={{
                                  width: '100%',
                                }}
                                options={data.map((item) => {
                                  return { label: item.name, value: item.id };
                                })}
                                onChange={(label, value) => {
                                  handleChange(value);
                                }}
                              />
                              {/* <Select
                                isMulti={true}
                                closeMenuOnSelect={false}
                                options={
                                  data.map((option) => ({
                                    value: option.value,
                                    label: option.name,
                                  })) || []
                                }
                                noOptionsMessage={() => ''}
                                placeholder="Chọn giá trị"
                                onChange={handleChange}
                                value={manyValue || []}
                              /> */}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <SingleSelect
                        label={'Giá trị'}
                        data={data || []}
                        displayValue={'name'}
                        value={(item) => {
                          setValue(item);
                        }}
                      />
                    ))}
                </div>
              </div>
              <div className="container flex justify-content-end">
                <button
                  type="button"
                  data-dismiss="modal"
                  ref={btnSaveRef}
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                  onClick={() => {
                    Save();
                  }}
                >
                  Lưu
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showSubOption == true && (
        <div
          className="modal fade show"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          style={{ display: 'block', paddingRight: '6px' }}
          role="dialog"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="w-full flex flex-col gap-3">
                  {subAttributes &&
                    subAttributes[attributeName[indexProperty]]?.map((item, index) => (
                      <div className="flex flex-row gap-3" key={index}>
                        <div className="w-full">
                          <label className="block mb-2 text-sm font-medium text-gray-900">
                            Giá trị SUBAttributes
                          </label>
                          <span className="border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                            {item.name}
                          </span>
                        </div>
                        <div className="w-full">
                          <div>Giá trị</div>
                          <Select
                            style={{ width: '100%' }}
                            defaultValue={
                              subAttributesValue[item.identityName]?.find(
                                (item) => item?.id == subOptionSelect?.[indexProperty]?.[index]?.id
                              )?.name
                            }
                            options={
                              subAttributesValue[item.identityName].map((item) => {
                                return { label: item.name, value: item.value, id: item.id };
                              }) || []
                            }
                            onChange={(_, value) => {
                              set_subOption((prevSubOption) => {
                                const newSubOption = { ...prevSubOption };
                                newSubOption[attributeName[indexProperty]] = {
                                  ...newSubOption[attributeName[indexProperty]],
                                  [item.identityName]: {
                                    ...value,
                                    name: item.identityName,
                                    op: 'eq',
                                  },
                                };
                                console.log(newSubOption);
                                return newSubOption;
                              });
                              // console.log(subOption);
                              // console.log(subOptionSelect?.[indexProperty]);
                              // console.log(value);
                              console.log(subOptionSelect);
                              set_subAttributesValueSelect(value);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div className="container flex justify-content-end">
                <button
                  type="button"
                  data-dismiss="modal"
                  ref={btnSaveRef}
                  disabled={
                    subOptionSelect?.[indexProperty]?.length ==
                    subAttributes?.[attributeName?.[indexProperty]]?.length
                      ? false
                      : true
                  }
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                  onClick={() => {
                    set_showSubOption(false);
                    // SaveSubOption();
                  }}
                >
                  Lưu
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Properties;
